export default __webpack_public_path__ + "static/media/Group 128.978e6e60.png";